import { SplitFactory } from '@splitsoftware/splitio';
const APIConfig = require('apiconfig');

export function getAccountId(): string {
  const camAccount = window.Reqres?.request('camAccount');
  const accountId = camAccount?.account_id || 'anonymous';

  return accountId;
}

export function getUserId(): string {
  const camAccount = window.Reqres?.request('camAccount');
  const currentUser = window.Reqres?.request('currentUser');

  let userId: string;

  if (camAccount?.twilio_sid) {
    userId = camAccount.twilio_sid;
  } else {
    userId = currentUser?.user_id?.toString() || 'anonymous';
  }

  return userId;
}

export function createSplitClient(key: string) {
  const splitFactory = SplitFactory({
    core: {
      authorizationKey: APIConfig.splitApiKey,
      key: key,
    },
  });

  const client = splitFactory.client();
  client.on(client.Event.SDK_READY, () => {
    const treatment = client.getTreatment('test-split-3');
    if (treatment === 'on') {
      console.debug(`Split.io feature test-split-3 is ON`);
    }
  });

  return client;
}
